import styled from '@emotion/styled';
import {
  palette,
  radius,
  shadow,
  spacing,
  transition,
  duration,
  easing,
  layout,
  typography,
} from '../../../../../style-utils/theme';

export const ParentContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: ${spacing.xs};
  padding: ${spacing.sm} 0;
`;

/* Arrow control — circular hit target, iris-wash hover, press-scale. */
export const ButtonContainer = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${layout.touchTarget};
  height: ${layout.touchTarget};
  border-radius: ${radius.circle};
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: ${transition.colors},
    transform ${duration.instant} ${easing.spring};

  &:hover {
    background: ${palette.irisTintSoft};
  }

  &:active {
    transform: scale(0.94);
  }

  &:focus-visible {
    outline: none;
    box-shadow: ${shadow.focus};
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: ${spacing.xxl};
  padding: 0 ${spacing.xs};
  color: ${palette.slate};
  font-family: ${typography.ui};
  font-size: ${typography.size.sm}px;
  font-weight: ${typography.weight.medium};
`;
